import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
} from "@pankod/refine-antd";
import { MyFormProps } from ".";
import { SaveOutlined } from "@ant-design/icons";

interface NewTemplateFormProps extends MyFormProps {
  title: string;
}

export const NewTemplateForm = ({ formProps, title }: NewTemplateFormProps) => (
  <Form {...formProps} layout="vertical">
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <h1>{title}</h1>
      </Col>

      <Col xs={24}>
        <Form.Item
          label="Nome do Template"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item
          label="Ordem de Disparo"
          name="order"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber min={0} style={{ width: "100%" }} type="number" />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item label="Última Tela" name="last_screen">
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item label="Tempo de Abandono" name="abandon_minutes">
          <InputNumber min={0} style={{ width: "100%" }} type="number" />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item label="Nome do Curl" name="curl_key">
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item label="Curl" name="curl">
          <Input.TextArea
            style={{
              height: "10rem",
              resize: "none",
              scrollbarWidth: "thin",
            }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} style={{ textAlign: "right" }}>
        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
          Salvar
        </Button>
      </Col>
    </Row>
  </Form>
);
